import React from "react";

const SeekBar = ({ currentTime, duration, onSeek }) => {
  const formatTime = (sec) => {
    if (!Number.isFinite(sec) || sec < 0) return "00:00";

    const minutes = Math.floor(sec / 60).toString().padStart(2, "0");
    const seconds = Math.floor(sec % 60).toString().padStart(2, "0");

    return `${minutes}:${seconds}`;
  };

  const safeDuration = Number.isFinite(duration) && duration > 0 ? duration : 0;
  const safeCurrentTime = Number.isFinite(currentTime) ? Math.min(currentTime, safeDuration || currentTime) : 0;

  return (
    <div className="flex select-none items-center gap-1 text-white">
      <span className="w-12 text-center text-xs">{formatTime(safeCurrentTime)}</span>

      <input
        type="range"
        min={0}
        max={safeDuration}
        step="0.01"
        value={safeDuration > 0 ? Math.min(safeCurrentTime, safeDuration) : 0}
        disabled={safeDuration <= 0}
        onChange={(e) => {
          const value = parseFloat(e.target.value);
          if (Number.isFinite(value)) onSeek(value);
        }}
        className="h-1 flex-grow cursor-pointer accent-purple-600 disabled:cursor-default"
      />

      <span className="w-12 text-center text-xs">{formatTime(safeDuration)}</span>
    </div>
  );
};

export default SeekBar;